import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';

import 'mmenu-js/src/mmenu';
import 'mmenu-js/dist/mmenu.polyfills';
//import 'mmenu-js/src/mmenu.debugger';

import 'imagesloaded';
import 'bootstrap-select';
import 'jquery-match-height';
import 'cookieconsent';
import 'slick-carousel';
import './vendor/jquery.fancybox';
import 'tooltipster';

import './parts/header';
import './parts/base';
import './parts/slick';
import './parts/tmt-svg';
import './parts/googleMap';


// WEBPACK FOOTER //
// ./js/main.js